import { FetchResult } from 'apollo-link';
import { DataProxy } from 'apollo-cache';

import {
  GetCurrentUserFeedDocument,
  GetFollowedDocument,
  Group,
  GroupStatus,
  UserFeedFollow,
  UserProfile,
} from 'api';
import { FOLLOW_QUERIES_LIMIT } from 'constants/index';

interface IGroupEditOptions {
  currentUser: UserProfile;
}

type GroupEdit = [DataProxy, FetchResult, IGroupEditOptions];

function getFollowsIndex(feedFollows: UserFeedFollow[], group: Group) {
  return feedFollows.findIndex((feedFollow: UserFeedFollow) => {
    const followId = feedFollow.group && feedFollow.group.id;
    return followId === group.id;
  });
}

function getModeratorIndex(user: UserProfile, group: Group) {
  return user.group_moderator.findIndex(moderatedGroup => moderatedGroup.group_id === group.id);
}

export const groupEdit = (...args: GroupEdit) => {
  const [cache, mutationResult, options] = args;
  const { currentUser } = options;
  const { updateGroup } = mutationResult.data;

  const followedCacheOptions = {
    query: GetFollowedDocument,
    variables: { data: { user_id: currentUser.id, limit: FOLLOW_QUERIES_LIMIT } },
  };
  const userFeedCacheOptions = {
    query: GetCurrentUserFeedDocument,
    variables: { user_id: currentUser.id },
  };

  const { getPaginatedUserFeedFollows } = cache.readQuery(followedCacheOptions);
  const { getByUserFeed } = cache.readQuery(userFeedCacheOptions);

  const { feed_follows } = getPaginatedUserFeedFollows;
  const { user } = getByUserFeed;

  const isDeleted = updateGroup.group_status === GroupStatus.Deleted;
  const followsIndex = getFollowsIndex(feed_follows, updateGroup);
  const moderatorIndex = getModeratorIndex(user, updateGroup);

  if (isDeleted) {
    feed_follows.splice(followsIndex, 1);
    user.group_moderator.splice(moderatorIndex, 1);
  } else {
    feed_follows[followsIndex].group = updateGroup;
  }

  cache.writeQuery({
    data: { getPaginatedUserFeedFollows },
    ...followedCacheOptions,
  });
  cache.writeQuery({
    data: { getByUserFeed },
    ...userFeedCacheOptions,
  });
};
